export class Constants {
  public static NEXPRESS_ENDPOINT = "https://api.dwtunnel.com/api/";
  public static NEXPRESS_LOGIN_ENDPOINT = "https://api.dwtunnel.com/";
  //public static NEXPRESS_ENDPOINT = "https://localhost:44375/api/";
  //public static NEXPRESS_LOGIN_ENDPOINT = "https://localhost:44375/";
  //public static NEXPRESS_ENDPOINT = 'https://api.dwtunnel.com/api/';
  //public static NEXPRESS_LOGIN_ENDPOINT = 'https://api.dwtunnel.com/';
  //public static NEXPRESS_ENDPOINT = 'https://apitest.dwtunnel.com/api/';
  //public static NEXPRESS_LOGIN_ENDPOINT = 'https://apitest.dwtunnel.com/';
  public static NEXPRESS_HOME_PAGE = "/";
  public static CARD_CONNECT_IFRAME_URL =
    "https://fts.cardconnect.com:8443/itoke/ajax-tokenizer.html";
  // Port 6443 is the testing server for card connect
  //public static CARD_CONNECT_IFRAME_URL = 'https://fts.cardconnect.com:6443/itoke/ajax-tokenizer.html';
  public static TOKEN = "token";
  public static ID = "id";
  public static EXPIRATION = "expires";
  public static AMEX_REGEX = /^3[47][0-9]{13}/;
  public static DINERS_REGEX = /^30[0-5]\d{11}/;
  public static DISCOVER_REGEX = /^6(?:011\d{12}|5\d{14}|4[4-9]\d{13}|22(?:1(?:2[6-9]|[3-9]\d)|[2-8]\d{2}|9(?:[01]\d|2[0-5]))\d{10})$/;
  public static VISA_REGEX = /^4\d{15}/;
  public static MASTERCARD_REGEX = /^5[1-5]\d{14}/;
  public static MAINTENANCE_MODE = false;
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/constants.ts